module.exports = __webpack_public_path__ + "img/select_title.49d05215.png";